import { NextRequest, NextResponse } from 'next/server';
import { db } from '@/lib/db';

export async function GET() {
  try {
    console.log('📊 Fetching admin stats...');
    
    // Get all users count
    const allUsers = await db.users.getAllUsers();
    const totalUsers = allUsers.length;
    
    // Get trainer and gym counts from their respective tables
    const { pool } = await import('@/lib/db');
    
    // Get total trainers from trainers table
    const [trainerCountRows] = await pool.execute(
      'SELECT COUNT(*) as total FROM trainers'
    );
    const totalTrainers = (trainerCountRows as any)[0]?.total || 0;
    
    // Get total gyms from gyms table
    const [gymCountRows] = await pool.execute(
      'SELECT COUNT(*) as total FROM gyms'
    );
    const totalGyms = (gymCountRows as any)[0]?.total || 0;
    
    // Get pending trainers
    const [pendingTrainerRows] = await pool.execute(
      'SELECT COUNT(*) as pending FROM trainers WHERE status = "pending"'
    );
    const pendingTrainers = (pendingTrainerRows as any)[0]?.pending || 0;
    
    // Get pending gyms
    const [pendingGymRows] = await pool.execute(
      'SELECT COUNT(*) as pending FROM gyms WHERE status = "pending"'
    );
    const pendingGyms = (pendingGymRows as any)[0]?.pending || 0;
    
    const stats = {
      totalUsers,
      totalTrainers,
      totalGyms,
      pendingTrainers,
      pendingGyms,
    };
    
    console.log('📈 Stats calculated:', stats);
    
    return NextResponse.json({
      success: true,
      stats
    });
  } catch (error) {
    console.error('❌ Error fetching stats:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    return NextResponse.json(
      { error: 'Failed to fetch stats: ' + errorMessage },
      { status: 500 }
    );
  }
}
